import { render, staticRenderFns } from "./editGym.vue?vue&type=template&id=c586038c&"
import script from "./editGym.vue?vue&type=script&lang=js&"
export * from "./editGym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports